import React, { useState } from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { Modal as BootstrapModal, Tab } from 'react-bootstrap'
import { CRMIntegrationSettings } from '../CRMIntegrationSettings'
import { Tabs } from '../../../../components/Tabs/Tabs'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { ContactSyncSettings } from '../ContactSyncSettings'

export type XLR8SettingsModalProps = {
  show: boolean
  onHide: () => void
}

export const XLR8SettingsModal: React.FC<XLR8SettingsModalProps> = ({ show, onHide }) => {
  const [activeTabKey, setActiveTabKey] = useState<string>('XLR8Mappings')
  const changeTab = (key: string | null) => {
    if (key) {
      setActiveTabKey(key)
    }
  }

  const XLR8SettingsModalBody = () => {
    return (
      <Tabs activeKey={activeTabKey} id='XLR8-settings' className='d-flex mb-3' onSelect={changeTab} mountOnEnter unmountOnExit>
        <Tab eventKey='XLR8Mappings' title='Mappings'>
          <CRMIntegrationSettings serviceId='xlr8' onSaved={onHide} onCancelled={onHide} />
        </Tab>
        <Tab eventKey='XLR8SyncSettings' title='Contact Sync'>
          <ContactSyncSettings serviceId='xlr8' />
        </Tab>
        <Tab eventKey='xlr8TaskSettings' title='Tasks'>
          <CRMIntegrationTaskSettings serviceId='xlr8' />
        </Tab>
      </Tabs>
    )
  }
  return (
    <Modal show={show} onHide={onHide} header={<BootstrapModal.Title>Edit XLR8 Integration Settings</BootstrapModal.Title>} body={<XLR8SettingsModalBody />} />
  )
}
